export const iiptoProgressBar = (type) => {
  const data = {
    1: '待提交资料',
    2: '待审核',
    3: '审核期',
    4: '资料被驳回',
    5: '律师审核',
    6: '待录入证据',
    20: '提交商标局',
    21: '收到审查意见',
    22: '已翻译审查意见',
    23: '待提交答复材料',
    24: '平台审核答复材料',
    25: '律师审核答复材料',
    26: '已答复审查意见',
    27: '答复材料有误',
    40: '收到暂停信',
    41: '已翻译暂停信',
  }
  return data[type]
}

export const iiptoFileType = (type) => {
  const data = {
    1: '受理回执',
    2: '受理书',
    3: '审查意见（OA）',
    4: '审查意见的答复函（OA）',
    7: '暂停信',
  }
  return data[type]
}

export const progressBarList = [
  {
    val: '待提交资料',
    key: '1',
  },
  {
    val: '初步审核',
    key: '2',
  },
  {
    val: '待录入证据',
    key: '6',
  },
  {
    val: '资料被驳回',
    key: '4',
  },
  {
    val: '律师审核',
    key: '5',
  },
  {
    val: '提交商标局',
    key: '3',
  },
  {
    val: '收到审查意见',
    key: '21',
  },
  {
    val: '已翻译审查意见',
    key: '22',
  },
  {
    val: '待提交答复材料',
    key: '23',
  },
  {
    val: '平台审核答复材料',
    key: '24',
  },
  {
    val: '律师审核答复材料',
    key: '25',
  },
  {
    val: '已答复审查意见',
    key: '26',
  },
  {
    val: '答复材料有误',
    key: '27',
  },
  {
    val: '收到暂停信',
    key: '40',
  },
  {
    val: '已翻译暂停信',
    key: '41',
  },
]


// WEBPACK FOOTER //
// ./src/libs/iipto.js